import { get } from "../lib/request";

export const storeIdApiCall = () => {
    let url = `/python-spark/store-category`;
    return get(url);
};
